import { day } from 'libs/day';
import { FlexCheckInStatuses, FtmReportFilters, FtmReportFilterType } from 'libs/domain';
import { ReportTypes } from 'libs/domain';
import { z } from 'zod';

import { withDateRangeSchema } from '@app/src/app/shared/services/filtering/utils/query-filtering.utils';

import { SelectFieldsOption } from '@shared/components/select-fields';

export enum FtmReportsMessages {
  BUTTON_APPLY_FILTER = 'Apply filters',
  BUTTON_CLEAR_FILTER = 'Clear filters',
  SELECT_ACTIVITY = 'Activity',
  SELECT_PERIOD = 'Period',
  SELECT_CHECKIN_STATUS = 'Status',
  SELECT_LABEL_USER_LIST = 'User list',
  UNREGISTERED_NO_PERIOD_ERROR = 'Need at least one period selected to find unregistered students',

  SHOW_FILTERS = 'Show filters',
  HIDE_FILTERS = 'Hide filters',
  HISTORY_LABEL = 'FlexTime History Report',
  UNREGISTERED_LABEL = 'FlexTime Unregistered Report',
  ACTIVITIES_LABEL = 'Activity Report',
  STUDENTS_LABEL = 'Student Report',
  STAFF_LABEL = 'Staff Report',
}

export const FtmReportPageOptions: SelectFieldsOption<ReportTypes>[] = [
  {
    value: ReportTypes.FLEX_PERIOD_REGISTERED,
    label: FtmReportsMessages.HISTORY_LABEL,
  },
  {
    value: ReportTypes.FLEX_PERIOD_UNREGISTERED,
    label: FtmReportsMessages.UNREGISTERED_LABEL,
  },
  {
    value: ReportTypes.FLEX_ACTIVITIES,
    label: FtmReportsMessages.ACTIVITIES_LABEL,
  },
  {
    value: ReportTypes.FLEX_STUDENTS,
    label: FtmReportsMessages.STUDENTS_LABEL,
  },
  { value: ReportTypes.FLEX_STAFF, label: FtmReportsMessages.STAFF_LABEL },
];

export const FTM_REPORTS_FILTER_INIT_STATE: FtmReportFilters = {
  periods: [],
  registrant: [],
  registerer: [],
  activities: [],
  startDate: day().subtract(7, 'd').startOf('day'),
  endDate: day().endOf('day'),
  userList: [],
};

export const FTM_REPORTS_FILTER_NON_ARRAY_TYPES = [
  FtmReportFilterType.CHECKIN_STATUS,
  FtmReportFilterType.START_DATE,
  FtmReportFilterType.END_DATE,
];

export const flexReportSchemaQuery = withDateRangeSchema().extend({
  registrant_hashes: z.array(z.string()).catch([]),
  registerer_hashes: z.array(z.string()).catch([]),
  period_ids: z.array(z.number()).catch([]),
  activity_ids: z.array(z.number()).catch([]),
  user_list_ids: z.array(z.number()).catch([]),
  check_in_statuses: z.array(z.nativeEnum(FlexCheckInStatuses)).catch([]),
});
export type FlexReportQueryParams = z.infer<typeof flexReportSchemaQuery>;

export const SUPPORTS_SCHEDULED_REPORTS = [
  ReportTypes.FLEX_PERIOD_REGISTERED,
  ReportTypes.FLEX_ACTIVITIES,
  ReportTypes.FLEX_STUDENTS,
  ReportTypes.FLEX_STAFF,
];
